import React from 'react'
import { node, func } from 'prop-types'

function SubmitOnEnter({ children, onSubmit }) {
  /*
   * HTML forms can only be submitted with
   * the enter key when a submit button is
   * present inside it
   */
  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        if (onSubmit) {
          onSubmit()
        }
      }}
    >
      {onSubmit && <input type="submit" style={{ display: 'none' }} />}
      {children}
    </form>
  )
}

SubmitOnEnter.propTypes = {
  children: node.isRequired,
  onSubmit: func
}

SubmitOnEnter.defaultProps = {
  onSubmit: null
}

export default SubmitOnEnter
